import {
  createRouter,
  createWebHistory /*createWebHashHistory*/,
} from "vue-router";
import Cookies from "js-cookie";
import service from "@/config/services";
import store from "./store/index";
import roles from "./config/roles";

import LoginView from "@/LoginView.vue";
import NotAuthorized from "@/NotAuthorized.vue";
import DashboardView from "@/DashboardView.vue";

import Home from "@/views/Home.vue";
import CaricamentoRcu from "@/components/caricamentoFile/rcu/CaricamentoRcu.vue";
import CaricamentoLetture from "@/components/caricamentoFile/rcu/CaricamentoLetture.vue";
import CaricamentoFileFornitori from "@/components/caricamentoFile/rcu/CaricamentoFileFornitori.vue";
import FattureFornitoriGrezze from "@/components/caricamentoFile/rcu/FattureFornitoriGrezze.vue";
import CaricamentoSwitchOut from "@/components/caricamentoFile/rcu/CaricamentoSwitchOut.vue";
import CaricamentoSwitchIn from "@/components/caricamentoFile/rcu/CaricamentoSwitchIn.vue";
import CaricamentoVT4 from "@/components/caricamentoFile/rcu/CaricamentoVT4.vue";
import CaricamentoAnnullamentoPratica from "@/components/caricamentoFile/rcu/CaricamentoAnnullamentoPratica.vue";
import SospensioniERiattivazioni from "@/components/caricamentoFile/rcu/SospensioniERiattivazioni.vue";
import LogFattureAgyo from "@/components/caricamentoFile/rcu/LogFattureAgyo.vue";
import UploadRcu from "@/components/caricamentoFile/rcu/UploadRcu.vue";
import InfoRcu from "@/components/caricamentoFile/rcu/InfoRcu.vue";
import SendGridLog from "@/components/caricamentoFile/rcu/SendGridLog.vue";
import DatabaseSync from "./components/caricamentoFile/rcu/DatabaseSync.vue";
import DatabaseSyncLogs from "./components/caricamentoFile/rcu/DatabaseSyncLogs.vue";
import DatabaseSyncLogsGroup from "./components/caricamentoFile/rcu/DatabaseSyncLogsGroup.vue";
import DatabaseSyncLogsDetails from "./components/caricamentoFile/rcu/DatabaseSyncLogsDetails.vue";
import Arera from "@/components/caricamentoFile/rcu/Arera.vue";
import Morosità from "@/components/caricamentoFile/rcu/Morosità.vue";
import CaricamentoFilePerCmor from "@/components/caricamentoFile/rcu/CaricamentoFilePerCmor.vue";
import DettaglioRaccolta from "./components/caricamentoFile/rcu/DettaglioRaccolta.vue";
import DettaglioRaccoltaIstanza from "./components/caricamentoFile/rcu/DettaglioRaccoltaIstanza.vue";
import VersioniDocumenti from '@/views/VersioniDocumenti.vue'


const routes = [
  {
    path: "/login",
    name: "Login",
    component: LoginView,
  },
  {
    path: "/unauthorized",
    name: "Unauthorized",
    component: NotAuthorized,
  },
  {
    path: "/",
    component: DashboardView,
    children: [
      {
        path: "/",
        component: Home,
      },
      {
        path: "/caricamentoRcu",
        name: "CaricamentoRcu",
        component: CaricamentoRcu,
      },
      {
        path: "/CaricamentoLetture",
        name: "CaricamentoLetture",
        component: CaricamentoLetture,
      },
      {
        path: "/CaricamentoFileFornitori",
        name: "CaricamentoFileFornitori",
        component: CaricamentoFileFornitori,
      },
      {
        path: "/FattureFornitoriGrezze",
        name: "FattureFornitoriGrezze",
        component: FattureFornitoriGrezze,
      },
      {
        path: "/CaricamentoSwitchOut",
        name: "CaricamentoSwitchOut",
        component: CaricamentoSwitchOut,
      },
      {
        path: "/CaricamentoSwitchIn",
        name: "CaricamentoSwitchIn",
        component: CaricamentoSwitchIn,
      },
      {
        path: "/CaricamentoVT4",
        name: "CaricamentoVT4",
        component: CaricamentoVT4,
      },
      {
        path: "/CaricamentoAnnullamentoPratica",
        name: "CaricamentoAnnullamentoPratica",
        component: CaricamentoAnnullamentoPratica,
      },
      {
        path: "/SospensioniERiattivazioni",
        name: "SospensioniERiattivazioni",
        component: SospensioniERiattivazioni,
      },
      {
        path: "/LogFattureAgyo",
        name: "LogFattureAgyo",
        component: LogFattureAgyo,
      },
      {
        path: "/UploadRcu",
        name: "UploadRcu",
        component: UploadRcu,
      },
      {
        path: "/InfoRcu",
        name: "InfoRcu",
        component: InfoRcu,
      },
      {
        path: "/SendGridLog",
        name: "SendGridLog",
        component: SendGridLog,
      },
      {
        path: "/databaseSync/:group_id?",
        name: "databaseSync",
        component: DatabaseSync,
      },
      {
        path: "/databaseSyncLogs",
        name: "databaseSyncLogs",
        component: DatabaseSyncLogs,
      },
      {
        path: "/databaseSyncLogsGroup/:group_id",
        name: "databaseSyncLogsGroup",
        component: DatabaseSyncLogsGroup,
      },
      {
        path: "/databaseSyncLogsDetails/:id",
        name: "databaseSyncLogsDetails",
        component: DatabaseSyncLogsDetails,
      },
      {
        path: "/databaseSyncConf",
        name: "databaseSyncConf",
        component: DatabaseSyncConf,
      },
      {
        path: "/databaseSyncJobLogs",
        name: "databaseSyncJobLogs",
        component: DatabaseSyncJobLogs,
      },
      {
        path: "/dettaglio-raccolta",
        name: "DettaglioRaccolta",
        component: DettaglioRaccolta,
      },
      {
        path: "/Arera",
        name: "Arera",
        component: Arera,
      },
      {
        path: '/morosita',
        name: 'Morosità',
        component: Morosità,
      },
      {
        path: '/cmor',
        name: 'CaricamentoFilePerCmor',
        component: CaricamentoFilePerCmor,
      },
      {
        path: '/dettaglio-raccolta/:id',
        name: 'DettaglioRaccolta',
        component: DettaglioRaccolta,
      },
      {
        path: '/dettaglio-raccolta-istanza/:id',
        name: 'DettaglioRaccoltaIstanza',
        component: DettaglioRaccoltaIstanza,
      },
      {
        path: "/flussiCaricati",
        name: "lettureLogs",
        component: LettureLogs,
      },
      {
        path: "/flussiOre",
        name: "flussiOre",
        component: FlussiOre,
      },
      {
        path: "/sms",
        name: "Sms",
        component: SmsTemplates,
      },
      {
        path: "/caricamentoPun",
        name: "CaricamentoPun",
        component: CaricamentoPun,
      },
      {
        path: "/caricamento-teamsystem",
        name: "caricamentoTeamsystem",
        component: CaricamentoTeamsystem,
      },
      {
        path: "/export-contabilita",
        name: "exportContabilita",
        component: ExportContabilita,
      },
      {
        path: "/fatture-pratiche",
        name: "fatturePratiche",
        component: FatturePratiche,
      },
      {
        path: "/allianz-status",
        name: "allianzStatus",
        component: AllianzServerStatus,
      },
      {
        path: '/versioni-documenti',
        name: 'Versioni documenti',
        component: VersioniDocumenti,
        beforeEnter: [hasProfiles],
        meta: {
          title: 'VERSIONI DOCUMENTI',
          profiles:['all']
        }
      },
      // {
      //   path: "/Lettura",
      //   name: "Lettura",
      //   component: Lettura,
      // },
      // {
      //   path: '/offerte',
      //   name: 'Offerta',
      //   component: Offerte,
      //   beforeEnter: [hasPermission],
      //   meta: { authorize: [roles.admin.role] },
      //   children: [
      //     {
      //       path: '/offerta/step-tipologia',
      //       component: StepTipologiaOfferta
      //     },
      //     {
      //       path: '/offerta/step-prezzi',
      //       component: StepPrezziOfferta
      //     },
      //     {
      //       path: '/offerta/step-gettone',
      //       component: StepGettoneOfferta
      //     },
      //     {
      //       path: '/offerta/step-riepilogo',
      //       component: StepRiepilogoOfferta
      //     },
      //   ]
      // },
    ],
  },
];

const router = createRouter({
  // history: createWebHashHistory(),
  history: createWebHistory(),
  routes,
});

function hasPermission(to, from, next) {
  const { authorize } = to.meta;
  const role = store.state.auth.user.role;

  if (authorize.length && !authorize.includes(role)) {
    console.log("access:denied");
    next({ path: "/" });
  } else {
    next();
  }
}

const setCookie = (name, cookie) => {
  if (cookie) {
    Cookies.set(name, JSON.stringify(cookie), {
      domain: `${service.main_domain.cookie}`,
      expires: 1,
    }); // 1 day
  }
};

const getAddSourceCookie = () => {
  let cookie = null;
  if (Cookies.get("google_access_token")) {
    cookie = JSON.parse(Cookies.get("google_access_token"));
    cookie.source = "google";
    //cookie.role = 'agent' // test
    setCookie("google_access_token", cookie);
  } else if (Cookies.get("ask_access_token")) {
    cookie = JSON.parse(Cookies.get("ask_access_token"));
    cookie.source = "jwt";
    setCookie("ask_access_token", cookie);
  }

  return cookie;
};

// refresh accessToken when expired
import AuthRefresh from "@/services/auth/auth.refresh";
router.beforeEach((to, from, next) => {
  const path = to.path;
  let cookie = getAddSourceCookie();

  if (path != "/unauthorized" && cookie) {
    // console.log(cookie);
    AuthRefresh.getLifetimeToken(cookie).then((secondToExpire) => {
      // console.log(secondToExpire);
      if (secondToExpire < 300) {
        // console.log('scaduto')
        AuthRefresh.getNewAccessToken(cookie).then(() => {
          next();
        });
      } else {
        next();
      }
    });
  } else {
    next();
  }
});

// Signin from cookie
import AuthService from "./services/auth/auth.service";
import LettureLogs from "./components/caricamentoFile/rcu/LettureLogs.vue";
import FlussiOre from "./components/caricamentoFile/rcu/FlussiOre.vue";
import SmsTemplates from "./components/sms/SmsTemplates.vue";
import CaricamentoPun from "./components/pun/CaricamentoPun.vue";
import CaricamentoTeamsystem from "./components/teamsystem/CaricamentoTeamsystem.vue";
import FatturePratiche from "./components/fatture/FatturePratiche.vue";
import ExportContabilita from "./components/contabilita/ExportContabilita.vue";
import AllianzServerStatus from "./components/allianz/AllianzServerStatus.vue";
import DatabaseSyncConf from "./components/sync/DatabaseSyncConf.vue";
import DatabaseSyncJobLogs from "./components/sync/DatabaseSyncJobLogs.vue";

router.beforeEach((to, from, next) => {
  let cookieToken = getAddSourceCookie();

  if (cookieToken) {
    if (to.name !== "Unauthorized") {
      AuthService.loginUserFromCookie(JSON.stringify(cookieToken))
        .then((res) => {
          if (res === true) {
            next();
          } else {
            next({ name: "Unauthorized" });
          }
        })
        .catch((err) => {
          console.log(err);
          next({ name: "Unauthorized" });
        });
    } else {
      next();
    }
  } else {
    if (to.name !== "Unauthorized") {
      next({ name: "Unauthorized" });
    } else {
      next();
    }
  }
});

function hasProfiles(to, from, next) {
  const profiles  = to.meta.profiles ?? [];
  const userLoggedStorage = localStorage.getItem('user') != null ? JSON.parse(atob(localStorage.getItem('user'))) : null
  
  if (!userLoggedStorage) {
    next()
  } else {
    const userProfile = userLoggedStorage.user[0].profile
    let allowed = profiles.some(profile => profile in userProfile && userProfile[profile] == 1)
    if (allowed) {
      next()
    } else {
      console.log('access:denied-profiles')
      next({ path: '/login' });
    }
  }
}

export default router;
